import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _OutcomesEditPanel;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import OutcomeAlignments from '@instructure/outcomes-ui/es/containers/OutcomeAlignments';
import { liveRegion, withStyleOverrides } from '@instructure/quiz-common';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import { CustomPropTypes, Card } from '@instructure/quiz-core';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/es/format-message';
export var OutcomesEditPanel = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_OutcomesEditPanel = /*#__PURE__*/function (_Component) {
  function OutcomesEditPanel() {
    var _this;
    _classCallCheck(this, OutcomesEditPanel);
    _this = _callSuper(this, OutcomesEditPanel);
    _defineProperty(_this, "renderOutcomeAlignments", function () {
      return jsx(OutcomeAlignments, {
        "data-testId": "outcome-lignments-test"
        // This is within the Build page, so no applicable launch contexts to pass
        ,
        alignmentSetId: _this.workingQuiz().outcomeAlignmentSetGuid,
        artifactId: _this.props.quiz.id,
        artifactType: "quiz",
        artifactTypeName: t('Quiz'),
        contextUuid: _this.props.contextUuid,
        displayMasteryDescription: true,
        displayMasteryPercentText: true,
        emptySetHeading: t('Align Institution outcomes to this quiz'),
        host: _this.props.outcomesEndpoint,
        jwt: _this.props.outcomesToken,
        onUpdate: _this.onOutcomeAlignmentSetChange,
        screenreaderNotification: _this.props.screenreaderNotification,
        liveRegion: liveRegion,
        readOnly: false
      });
    });
    _this.onOutcomeAlignmentSetChange = _this.onOutcomeAlignmentSetChange.bind(_this);
    return _this;
  }
  _inherits(OutcomesEditPanel, _Component);
  return _createClass(OutcomesEditPanel, [{
    key: "quizID",
    value: function quizID() {
      return this.props.quiz.id;
    }
  }, {
    key: "workingQuiz",
    value: function workingQuiz() {
      return this.props.quiz.getWorkingInstance();
    }
  }, {
    key: "onOutcomeAlignmentSetChange",
    value: function onOutcomeAlignmentSetChange(outcomeAlignmentSet) {
      this.props.changeQuizOutcomeAlignmentSetGuid(this.quizID(), outcomeAlignmentSet.guid);
      this.props.saveQuizChange(this.workingQuiz(), this.props.quiz);
    }
  }, {
    key: "render",
    value:
    // TODO: the prop type error from liveRegion is wrong -- we're waiting on Outcomes to fix it. Once fixed we should
    // remove the prop type error from the whitelist in tests.bundle.js
    function render() {
      if (this.props.isEditing) {
        return jsx(Card, {
          wrapped: true,
          css: this.props.styles.card,
          wrapperStyles: this.props.styles.wrapper
        }, jsx("div", {
          css: this.props.styles.label
        }, jsx(Heading, {
          level: "h4",
          as: "h2"
        }, t('Align Outcomes to Quiz'))), jsx("div", {
          css: this.props.styles.content
        }, this.renderOutcomeAlignments()));
      } else {
        return null;
      }
    }
  }]);
}(Component), _defineProperty(_OutcomesEditPanel, "displayName", 'OutcomesEditPanel'), _defineProperty(_OutcomesEditPanel, "componentId", "Quizzes".concat(_OutcomesEditPanel.displayName)), _defineProperty(_OutcomesEditPanel, "propTypes", {
  appContainer: CustomPropTypes.selectors.isRequired,
  quiz: ImmutablePropTypes.record.isRequired,
  contextUuid: PropTypes.string.isRequired,
  outcomesEndpoint: PropTypes.string.isRequired,
  outcomesToken: PropTypes.string.isRequired,
  isEditing: PropTypes.bool.isRequired,
  changeQuizOutcomeAlignmentSetGuid: PropTypes.func.isRequired,
  saveQuizChange: PropTypes.func.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  styles: PropTypes.object
}), _OutcomesEditPanel)) || _class);
export default OutcomesEditPanel;